const GoldMedalIcon = ({ size = 14 }: { size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {/* Ribbon */}
        <path
            d="M7 2h4l1 4-3 2-3-2 1-4zM13 2h4l-1 4-3 2-3-2 1-4z"
            fill="#F59E0B"
        />
        {/* Medal circle */}
        <circle cx="12" cy="15" r="6" fill="#FBBF24" />
        {/* Inner shine */}
        <circle cx="12" cy="15" r="4" fill="#FDE68A" />
        {/* Star */}
        <path
            d="M12 12.8l.9 1.9 2.1.3-1.5 1.4.4 2.1-1.9-1-1.9 1 .4-2.1-1.5-1.4 2.1-.3.9-1.9z"
            fill="#B45309"
        />
    </svg>
);

export default GoldMedalIcon